import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/me.jpg";
import Tilt from "react-parallax-tilt";
import { useTranslation } from "react-i18next";
import { getImageURL } from "../../api";

function Home2({ profile }) {
  const { i18n, t } = useTranslation();
  const lang = i18n.language.split("-")[0];

  const introDescription =
    profile?.hero?.description?.[lang] ||
    (lang === "uz"
      ? "Men g'oyalarni ishonchli mahsulotlarga aylantirishni yaxshi ko'radigan dasturchiman."
      : "I’m a Software Engineer who loves transforming ideas into reliable, scalable products.");

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>{t("introduce_myself")}</h1>
            <p className="home-about-body">{introDescription}</p>
          </Col>
          <Col md={4} className="myAvatar">
            <Tilt>
              <img
                src={getImageURL(profile?.about?.image) || myImg}
                className="img-fluid rounded-full"
                alt="avatar"
                style={{ borderRadius: "50%" }}
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
